/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeoBoundarySummary } from './GeoBoundarySummary';
import {
    GeoBoundarySummaryFromJSON,
    GeoBoundarySummaryFromJSONTyped,
    GeoBoundarySummaryToJSON,
    GeoBoundarySummaryToJSONTyped,
} from './GeoBoundarySummary';

/**
 * 
 * @export
 * @interface FindAllGeoBoundaries200Response
 */
export interface FindAllGeoBoundaries200Response {
    /**
     * 
     */
    data?: Array<GeoBoundarySummary>;
}

/**
 * Check if a given object implements the FindAllGeoBoundaries200Response interface.
 */
export function instanceOfFindAllGeoBoundaries200Response(value: object): value is FindAllGeoBoundaries200Response {
    return true;
}

export function FindAllGeoBoundaries200ResponseFromJSON(json: any): FindAllGeoBoundaries200Response {
    return FindAllGeoBoundaries200ResponseFromJSONTyped(json, false);
}

export function FindAllGeoBoundaries200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllGeoBoundaries200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GeoBoundarySummaryFromJSON)),
    };
}

export function FindAllGeoBoundaries200ResponseToJSON(json: any): FindAllGeoBoundaries200Response {
    return FindAllGeoBoundaries200ResponseToJSONTyped(json, false);
}

export function FindAllGeoBoundaries200ResponseToJSONTyped(value?: FindAllGeoBoundaries200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GeoBoundarySummaryToJSON)),
    };
}

